export const GRC18956_REGIONS = ['North America', 'South America', 'Europe', 'Asia', 'Africa'];

export const isGrc18956GLData = (controlId: string, dataType: string): boolean =>
  controlId === 'grc18956' && dataType === 'GL';

export const shouldSkipRegionFilter = (
  filterName: string,
  controlId: string,
  dataType: string
): boolean => filterName.toLowerCase() === 'region' && isGrc18956GLData(controlId, dataType);
